<template>
  <div class="container-decreto" :class="{show:isShowDecreto}">
    <button class="toggle-decreto" @click="toggleDecreto">
      <svg v-if="isShowDecreto" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/></svg>
      <svg v-else  xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor" class="icon-c">
          <g><rect fill="none" height="24" width="24"/></g><g><path d="M15,22H6c-1.1,0-2-0.9-2-2V4c0-1.1,0.9-2,2-2h8l6,6v6h-2V9h-5V4H6v16h9V22z M19,21.66l0-2.24l2.95,2.95l1.41-1.41L20.41,18 h2.24v-2H17v5.66H19z"/></g>
      </svg>
    </button>
    <a class="btn-decreto" v-if="isShowDecreto" href="https://www.dof.gob.mx/nota_detalle.php?codigo=5646249&fecha=22/03/2022" target="_blank" rel="noopener">
      <span class="btn-icon" aria-hidden="true"> 
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor" class="icon">
          <g><rect fill="none" height="24" width="24"/></g><g><path d="M15,22H6c-1.1,0-2-0.9-2-2V4c0-1.1,0.9-2,2-2h8l6,6v6h-2V9h-5V4H6v16h9V22z M19,21.66l0-2.24l2.95,2.95l1.41-1.41L20.41,18 h2.24v-2H17v5.66H19z"/></g>
        </svg>
      </span>
      Leer Decreto <span class="a11y-solo-lectura"> (Link externo).</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'BotonDecreto',
  computed: {
    isShowDecreto () {
      return this.$store.getters.isShowDecreto
    }
  },
  methods: {
    toggleDecreto () {
      this.$store.commit('toggleDecreto')
    }
  }
}
</script>

<style scoped lang="scss">

$accion: black;
$accion-hover: #052f7b;
$action-detail: #D2FEE7;
$space: 36px;

$bg-color-d:white;
$color-d:black;

@keyframes iconBtn {
  0% {
    opacity: .25;
    top: 17px;
  }
  50% {
    opacity: 1;
    top: 5px;
  }
  100% {
    top: 17px;
    opacity: .25;
  }
}

.container-decreto {
  background-color: $accion;
  border-radius: 25px;
  position: fixed;
  left: $space*.5;
  bottom: $space*.5;
  z-index: 99998;
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 25px;
  transition: all .4s ease-in-out;
  display: flex;
  align-content: center;
  border: none;
  -webkit-box-shadow: 2px 2px 11px 2px rgba(74,74,74,0.77);
  box-shadow: 2px 2px 11px 2px rgba(74,74,74,0.77);
  &.show {
    width: 250px;
  }
  
}
.toggle-decreto {
  background-color: $bg-color-d;
  border-radius: 25px 0 0 25px;
  flex: 0 0 50px;
  width: 50px;
  transition: all .3s ease-in-out;
  margin: 0;
  color: $color-d;
  .icon-c{
    color: $color-d;
  }
  &:hover{
    background-color: black;
    color: white;
    .icon-c{
      color: white;
    }
  }
  &:focus{
    background-color: black;
    color: white;
    .icon-c{
      color: white;
    }
  }
}
.btn-decreto {
  white-space: nowrap;
  color: $color-d;
  background-color: $bg-color-d;
  line-height: 50px;
  white-space: nowrap;
  padding-right: $space;
  transition: all .3s ease-in-out;
  border-left: 1px solid rgba(0, 0, 0, 0.25);
  flex: 1 1 80vw;
  white-space: nowrap;
  &:hover{
    background-color: black;
    color: white;
    border-left: 1px solid rgba(51, 49, 49, 0.411);
  }
  &:focus{
    background-color: black;
    color: white;
    border-left: 1px solid rgba(51, 49, 49, 0.411);
  }
  .btn-icon {
    margin: 0 $space*.25;
    .icon {
      position: relative;
      animation: iconBtn 2s ease-in-out infinite;
    }
  }
}
</style>
